export const LVG_ORDER_STATE = {
  PENDING: 'pending',
  LIVE: 'live',
  CANCELLED: 'cancelled',
  BUSTED: 'busted',
  CLOSING: 'closing',
  CLOSED: 'closed',
  UPDATING: 'updating',
  FUNDING: 'funding',
}
